import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLanguageFromUrl } from 'shared/helpers/parseUrl';
import { Key } from 'i18n/Key';

import en from 'i18n/translations/en.json';
import it from 'i18n/translations/it.json';
import sv from 'i18n/translations/sv.json';
import ro from 'i18n/translations/ro.json';
import bg from 'i18n/translations/bg.json';
import hr from 'i18n/translations/hr.json';
import nl from 'i18n/translations/nl.json';
import es from 'i18n/translations/es.json';
import fr from 'i18n/translations/fr.json';
import pt from 'i18n/translations/pt.json';
import ru from 'i18n/translations/ru.json';
import tr from 'i18n/translations/tr.json';
import de from 'i18n/translations/de.json';
import ja from 'i18n/translations/ja.json';
import ko from 'i18n/translations/ko.json';
import th from 'i18n/translations/th.json';
import vi from 'i18n/translations/vi.json';
import zh from 'i18n/translations/zh.json';
import el from 'i18n/translations/el.json';
import fi from 'i18n/translations/fi.json';
import id from 'i18n/translations/id.json';
import no from 'i18n/translations/no.json';
import uk from 'i18n/translations/uk.json';

export const DEFAULT_NS = 'translation';
export const DEFAULT_LANG = 'en';

const resources = {
  en: {
    [DEFAULT_NS]: en,
  },
  it: {
    [DEFAULT_NS]: it,
  },
  sv: {
    [DEFAULT_NS]: sv,
  },
  ro: {
    [DEFAULT_NS]: ro,
  },
  bg: {
    [DEFAULT_NS]: bg,
  },
  hr: {
    [DEFAULT_NS]: hr,
  },
  nl: {
    [DEFAULT_NS]: nl,
  },
  es: {
    [DEFAULT_NS]: es,
  },
  fr: {
    [DEFAULT_NS]: fr,
  },
  pt: {
    [DEFAULT_NS]: pt,
  },
  ru: {
    [DEFAULT_NS]: ru,
  },
  tr: {
    [DEFAULT_NS]: tr,
  },
  de: {
    [DEFAULT_NS]: de,
  },
  ja: {
    [DEFAULT_NS]: ja,
  },
  ko: {
    [DEFAULT_NS]: ko,
  },
  th: {
    [DEFAULT_NS]: th,
  },
  vi: {
    [DEFAULT_NS]: vi,
  },
  zh: {
    [DEFAULT_NS]: zh,
  },
  el: {
    [DEFAULT_NS]: el,
  },
  fi: {
    [DEFAULT_NS]: fi,
  },
  id: {
    [DEFAULT_NS]: id,
  },
  no: {
    [DEFAULT_NS]: no,
  },
  uk: {
    [DEFAULT_NS]: uk,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getLanguageFromUrl(),
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export const addDefaultTranslates = (
  trans: { [key in keyof typeof Key]?: string },
) => {
  const defaultTrans = i18n.getResourceBundle(DEFAULT_LANG, DEFAULT_NS);
  Object.entries(trans).forEach(([key, img]) => {
    if (!defaultTrans[img])
      i18n.addResources(DEFAULT_LANG, DEFAULT_NS, { [key]: img });
  });
};
